import { connect } from 'react-redux';

import ReviewsWrapper from './ReviewsWrapper';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';

export default connect(mapStateToProps, mapDispatchToProps)(ReviewsWrapper);
